import Vue from 'vue'
import Router from 'vue-router'

import HelloWorld from '@/components/HelloWorld'
import about from '@/view/about'
import product from '@/view/product'
import news from '@/view/news'
import contact from '@/view/contact'
import pdetail from '@/view/pdetail'
import ndetail from '@/view/ndetail'




Vue.use(Router)


export default new Router({
  linkActiveClass:"is-active",
  mode:'history',
  routes: [
    {
      path: '/',
      alias:'/index',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        title: '首页'
      }
    },
    {
      path: '/about/:aboutId?',
      name: 'About',
      component: about,
      meta: {
        title: '关于我们'
      }
    },
    {
      path: '/product/:productId?',
      //name: 'Product',
      component: product,
      meta: {
        title: ''
      }
    },
    {
      path: '/product/dtails/:pId?',
      //name: 'Product',
      component:pdetail,
      meta: {
        title: ''
      }
    },
    {
      path: '/news/:newId?',
      component: news,
      meta: {
        title: '新闻资讯'
      }
    },
    {
      path:'/news/details/:pId?',
      component:ndetail,
      meta: {
        title: '新闻资讯'
      }
    },
    {
      path: '/contact',
      name: 'Contact',
      component: contact,
      meta: {
        title: '联系我们'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ],

 
  
})



// WEBPACK FOOTER //
// ./src/router/index.js